import { gql } from '@apollo/client'
import { BOUNDING_BOXES_FRAGMENT } from './BoundingBoxesFragment'
import { SIMPLE_PRODUCT_FRAGMENT } from './SimpleProductFragment'

export const TRAINING_IMAGE_FRAGMENT = gql`
  fragment TrainingImage on TrainingImage {
    id
    url
    bucketFileName
  }
  ${BOUNDING_BOXES_FRAGMENT}
  ${SIMPLE_PRODUCT_FRAGMENT}
`
